import React from 'react'
import { Outlet } from 'react-router-dom'

const PortfolioLayout = () => {
    return (
        <div className="PortfolioLayout">
            <Outlet />
        </div>
    )
}

export default PortfolioLayout
